<template>
  <div class="patient-info-block">
    <div class="patient-select">
      <label>{{ $t('select-patient') }}: </label>
      <v-select @input="selectPatient" class="style-chooser"
                :placeholder="$t('Select patient')"
                style="background: white; border-radius: 10px; width: 12vw; color: rgb(19,89,103);"
                label="name"
                v-model="selectedPatientId"
                :reduce="data => data.id"
                :options="patients">
        <span slot="no-options">{{$t('No options')}}</span>
      </v-select>
    </div>
    <div class="bo dev">
      <div class="tabs">
        <a v-on:click="setActiveTab(1)" v-bind:class="[tab === 1 ? 'active' : '' ]">{{ $t('Alarms') }}</a>
        <a v-on:click="setActiveTab(2)" v-bind:class="[tab === 2 ? 'active' : '' ]">{{ $t('Alarms settings') }}</a>
        <a v-on:click="setActiveTab(3)" v-bind:class="[tab === 3 ? 'active' : '' ]">{{ $t('History') }}</a>
        <a v-on:click="setActiveTab(4)" v-bind:class="[tab === 4 ? 'active' : '' ]">{{ $t('patient-settings') }}</a>
        <a v-if="$store.state.user.features.addPatient" v-on:click="setActiveTab(5)" v-bind:class="[tab === 5 ? 'active' : '' ]">{{ $t('add-patient') }}</a>
        <a v-on:click="setActiveTab(6)" v-bind:class="[tab === 6 ? 'active' : '' ]">{{ $t('Behaviour') }}</a>
      </div>

      <div class="content">
        <!-- Displays alarms page -->
        <div v-if="tab === 1" class="tabcontent">
          <AlarmsList></AlarmsList>
        </div>

        <!-- Displays Alarms settings page -->
        <div v-if="tab === 2" class="tabcontent">
          <AlarmsSettings></AlarmsSettings>
        </div>

        <!-- Displays two graphs, first is Chart.vue, second is Channel.vue  -->
        <div v-if="tab === 3" class="tabcontent">
          <History></History>
        </div>

        <!-- Displays Patient settings -->
        <div v-if="tab === 4" class="tabcontent">
          <PatientSettings></PatientSettings>
        </div>

        <div v-if="tab === 5" class="tabcontent">
          <PatientSettingsNew is-new="true"></PatientSettingsNew>
        </div>

        <div v-if="tab === 6" class="tabcontent">
          <DeviceSettings/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlarmsSettings from './AlarmsSettings'
import AlarmsList from './AlarmsList'
import PatientSettings from './PatientSettings'
import PatientSettingsNew from './PatientSettings'
import {mapState, mapMutations} from 'vuex';
import History from "./History";
import DeviceSettings from "./DeviceSettings";
/* eslint-disable */
export default {
  name: 'PatientInfo',
  props: [],
  data() {
    return {
      results: [],
      user: '',
      selectedPatientId: null
    }
  },

  components: {
    DeviceSettings,
    History,
    AlarmsSettings,
    AlarmsList,
    PatientSettings,
    PatientSettingsNew
  },

  computed: {
    ...mapState({
      modalData: 'modalData',
      patients: 'patients'
    }),

    tab() {
      return this.modalData.activeTab || 1;
    }
  },

  methods: {
    //sets user for displaying graph, for select patient to change patient so can see other patient graph
    setUser(info) {
      this.user = info;
      console.log("info", this.user);
    },
    selectPatient() {
      console.log('selectPatient', this.selectedPatientId);
      let patient = this.patients.find((patient) => patient.id === this.selectedPatientId);
      this.$store.commit('setSelectedPatient', patient);
    },
    ...mapMutations([
      'setActiveTab'
    ])
  },
  mounted() {
    this.selectedPatientId = this.$store.state.selectedPatient ? this.$store.state.selectedPatient.id : null;
    this.$store.dispatch('loadPatients');
  },
}
</script>


<style>
div.c1 {
  margin: 3px;
  border-radius: 3px;
}

.bo.d {
  text-align: left;
  margin-bottom: 10px;
}

.bo.dev {
  text-align: left;
}

.bo {
  background: linear-gradient(90deg, rgba(52, 100, 129, 1) 52%, rgba(60, 131, 148, 1) 64%, rgba(66, 147, 167, 1) 81%);
  margin-top: 10px;
  color: white;
  font-family: "Chivo", sans-serif;
  font-size: 1vw;
  font-weight: bold;
}

.back {
  top: 0;
  position: fixed;
  left: 0;
  text-decoration: underline;
  cursor: pointer;
}

.tab {
  text-align: left;
  border: none;
}

.tablinks {
  border-radius: 10px 10px 0 0;
  width: 25%;
  margin-right: 10px;
  border: none;
  background-color: #3a5675;
  font-weight: bold;
}

.graphs {
  border-radius: 10px 10px 0 0;
  border-color: rgba(66, 147, 167, 0.2)
}

.csv {
  background-color: white;
  color: rgb(19, 89, 103);
  font-weight: bold;
  border-style: solid;
  border-color: white;
  border-radius: 10px;
  font-family: "Chivo", sans-serif;
  font-size: 1vw;
  position: relative;
  left: 50%;
  bottom: 0.5vw;
}

table {
  width: 100%;
}

.top2 {
  border-bottom: solid 1px;
  padding-bottom: 10px;
  padding-top: unset;
}

.container {
  max-width: 620px;
  min-width: 420px;
  margin: 40px auto;
  font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
  color: #888;
}

/* Style the tabs */
.tabs {
  margin-left: 20px;
  margin-bottom: -2px;
  border-radius: 10px 10px 0 0;
  padding-top: 10px;
  font-weight: bold;
  display: flex;
  width: 80%;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 12px 24px;
  background-color: #3a5675;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  margin-right: 10px;
  border: none;
  text-align: center;
  font-size: 1.5vw;
  color: #9cb4db;
}

.tabs a:last-child {
  border-right: 1px solid blue;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #ebe8e8;
  color: #484848;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 2px solid #798eb0;
  border-radius: 10px 10px 0px 0px;
  box-shadow: 3px 3px 6px #e1e1e1;
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientInfo.vue